import React, { useEffect } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

import VerticalList from '../../components/List/vertical-list';
import whatsNew from './release-notes';

import './ReleaseNotes.css';

const ReleaseNotes = () => {
  useEffect(() => {
    document.title = 'Release Notes | CVM Insights';
  }, []);
  return (
    <section className="tvt-main__content">
      <Grid fluid componentClass="section">
        <Row>
          <Col md={12}>
            <header className="tvt-main__header">
              <div className="page-header-root">
                <h1 className="page-header__title">Release Notes</h1>
              </div>
            </header>
            <VerticalList hideTitle list={whatsNew} />
          </Col>
        </Row>
      </Grid>
    </section>
  );
};

export default ReleaseNotes;
